import styled from "@emotion/styled";

export const WorkspaceListItem = styled.li`
  display: grid;
  justify-content: start;
  grid-template-columns: 0.2fr 1fr 1fr 1fr 1fr 1fr 0.2fr;
  color: ${(props) => props.theme.colors.onBackGround};
  align-items: start;
  padding: 16px 0;
  cursor: pointer;
  &:hover {
    box-shadow: ${(props) => props.theme.shadow.small};
    transition: box-shadow 0.5s;
  }
`;

export const WorkspaceListText = styled.span`
  word-break: break-all;
  font-weight: 500;
  padding-right: 16px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0px 8px;
  gap: 8px;
`;

export const GridSpacer = styled.div``;
